//rotateing gear
import React, { useEffect, useState } from "react";

const Loader = ({ size = 150 }) => {
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setRotation((prev) => prev + 10);
    }, 50);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        position: "relative"
      }}
    >
      {/* Rotating Gear */}
      <img
        src="/gear.png"
        alt="Gear"
        style={{
          width: size,
          height: size,
          position: "absolute",
          transform: `rotate(${rotation}deg)`,
          transition: "transform 0.05s linear"
        }}
      />
      
      {/* Fixed Wrench */}
      <img
        src="/wrench.png"
        alt="Wrench"
        style={{
          width: size * 0.9, // Slightly smaller than gear
          height: size * 0.9,
          position: "absolute"
        }}
      />
    </div>
  );
};

export default Loader;

//up and down
// import React, { useState, useEffect } from "react";

// const Loader = ({ size = 150 }) => {
//   const [position, setPosition] = useState(0);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setPosition((prev) => (prev === 0 ? -20 : 0));
//     }, 500);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div style={{
//       display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", position: "relative"
//     }}>
//       <img
//         src="/gear.png"
//         alt="Gear"
//         style={{
//           width: size,
//           height: size,
//           position: "absolute",
//           transform: `translateY(${position}px)`,
//           transition: "transform 0.5s ease-in-out"
//         }}
//       />
//       <img
//         src="/wrench.png"
//         alt="Wrench"
//         style={{
//           width: size * 0.7,
//           height: size * 0.7,
//           position: "absolute",
//           transform: `translateY(${-position}px)`,
//           transition: "transform 0.5s ease-in-out"
//         }}
//       />
//     </div>
//   );
// };

// export default Loader;

//Disappearing and Reappearing
// import React, { useState, useEffect } from "react";

// const Loader = ({ size = 150 }) => {
//   const [visible, setVisible] = useState(true);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setVisible((prev) => !prev);
//     }, 800);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div style={{
//       display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", position: "relative"
//     }}>
//       <img
//         src="/gear.png"
//         alt="Gear"
//         style={{
//           width: size,
//           height: size,
//           opacity: visible ? 1 : 0,
//           transition: "opacity 0.8s ease-in-out",
//           position: "absolute"
//         }}
//       />
//       <img
//         src="/wrench.png"
//         alt="Wrench"
//         style={{
//           width: size * 0.7,
//           height: size * 0.7,
//           opacity: visible ? 0 : 1,
//           transition: "opacity 0.8s ease-in-out",
//           position: "absolute"
//         }}
//       />
//     </div>
//   );
// };

// export default Loader;

//Spinning Wrench
// import React, { useState, useEffect } from "react";

// const Loader = ({ size = 150 }) => {
//   const [rotation, setRotation] = useState(0);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setRotation((prev) => prev + 10);
//     }, 100);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div style={{
//       display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", position: "relative"
//     }}>
//       <img src="/gear.png" alt="Gear" style={{ width: size, height: size, position: "absolute" }} />
//       <img
//         src="/wrench.png"
//         alt="Wrench"
//         style={{
//           width: size * 0.7,
//           height: size * 0.7,
//           position: "absolute",
//           transform: `rotate(${rotation}deg)`,
//           transition: "transform 0.1s linear"
//         }}
//       />
//     </div>
//   );
// };

// export default Loader;

//pulse style
// import React, { useState, useEffect } from "react";

// const Loader = ({ size = 150 }) => {
//   const [scale, setScale] = useState(1);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setScale((prev) => (prev === 1 ? 1.2 : 1));
//     }, 500);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div style={{
//       display: "flex", justifyContent: "center", alignItems: "center", height: "100vh"
//     }}>
//       <img
//         src="/final.png"
//         alt="Final Logo"
//         style={{
//           width: size,
//           height: size,
//           transform: `scale(${scale})`,
//           transition: "transform 0.5s ease-in-out"
//         }}
//       />
//     </div>
//   );
// };

// export default Loader;



